import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { Card, Button, Typography } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { APP_NAME } from "../helpers/constants";

const { Title, Text, Paragraph } = Typography;

const BackgroundCheckSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const tenantName = searchParams.get("tenantName") || "the tenant";

  const handleBackToDashboard = () => {
    navigate("/dashboard");
  };

  return (
    <Container>
      <SuccessCard>
        <Content>
          <IconWrap>
            <CheckCircleOutlined />
          </IconWrap>
          <Heading level={2}>Background Check Requested</Heading>
          <Description>
            We have sent an email to <strong>{tenantName}</strong> with
            instructions to complete their screening.
          </Description>
          <Subtext>
            You will be notified via email when the report is ready.
          </Subtext>
          <Button
            type="primary"
            size="large"
            onClick={handleBackToDashboard}
            style={{ marginTop: "24px" }}
          >
            Back to Dashboard
          </Button>
        </Content>
      </SuccessCard>
    </Container>
  );
};

export default BackgroundCheckSuccess;

// Styled Components
const Container = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;

  @media (max-width: 480px) {
    padding: 1rem;
  }
`;

const SuccessCard = styled(Card)`
  max-width: 500px;
  width: 100%;
  border-radius: 12px;
  border: none;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  background: white;
  .ant-card-body {
    padding: 3rem 2.5rem;
  }

  @media (max-width: 480px) {
    .ant-card-body {
      padding: 2rem 1.5rem;
    }
  }
`;

const Content = styled.div`
  text-align: center;
`;

const IconWrap = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #10b981;
  color: white;
  margin: 0 auto 24px auto;

  .anticon {
    font-size: 48px;
  }

  @media (max-width: 480px) {
    width: 64px;
    height: 64px;
    .anticon {
      font-size: 36px;
    }
  }
`;

const Heading = styled(Title)`
  && {
    color: #1f2937;
    margin: 0 0 16px 0;
    font-weight: 600;
    font-size: 28px;
  }

  @media (max-width: 480px) {
    && {
      font-size: 24px !important;
    }
  }
`;

const Description = styled(Paragraph)`
  && {
    font-size: 16px;
    color: #4b5563;
    margin: 0 0 8px 0;
    line-height: 1.6;
  }

  strong {
    color: #1f2937;
    font-weight: 600;
  }

  @media (max-width: 480px) {
    && {
      font-size: 15px;
    }
  }
`;

const Subtext = styled(Paragraph)`
  && {
    font-size: 14px;
    color: #6b7280;
    margin: 0 0 32px 0;
    line-height: 1.5;
  }

  @media (max-width: 480px) {
    && {
      font-size: 13px;
      margin-bottom: 24px;
    }
  }
`;
